// @generated by TypeGen from LogbookApi/DayApi.swift - DO NOT EDIT

import type { IAppResponse } from "../LogbookApp/Routes"
import type { IDayResponse, IDaysResponse } from "../LogbookModel/Day"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface IDayUpdateRequest {
  comment?: string;
  crew?: number[];
  data?: string;
  day?: number;
  endLocation?: string;
  passengers?: number[];
  skipper?: number;
  startLocation?: string;
}

export interface DayApiEndpoints {
  "GET /api/ships/:shipId/trips/:tripId/days": {
    params: { shipId: number; tripId: number };
    query: {};
    request: never;
    response: IDaysResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ships/:shipId/trips/:tripId/days": {
    params: { shipId: number; tripId: number };
    query: {};
    request: IDayUpdateRequest;
    response: IDayResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/days/:dayId": {
    params: { shipId: number; dayId: number };
    query: {};
    request: IDayUpdateRequest;
    response: IDayResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/days/:dayId/calculate": {
    params: { shipId: number; dayId: number };
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
}

export const dayApiEndpoints = {
  "GET /api/ships/:shipId/trips/:tripId/days": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewAll } },
  "POST /api/ships/:shipId/trips/:tripId/days": { targets: ["app", "server"], permission: { ship: IShipUserLevel.editCurrent } },
  "PUT /api/ships/:shipId/days/:dayId": { targets: ["app", "server"], permission: { ship: IShipUserLevel.editCurrent } },
  "PUT /api/ships/:shipId/days/:dayId/calculate": { targets: ["app"], permission: { session: true } },
} as const;

export class DayApi {
  constructor(private client: ApiClient) {}

  days = {
    list: (a: ApiArgs<DayApiEndpoints, "GET /api/ships/:shipId/trips/:tripId/days">) => ({
      call: (): Promise<IDaysResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/trips/:tripId/days", dayApiEndpoints["GET /api/ships/:shipId/trips/:tripId/days"].targets);
        return this.client.call<IDaysResponse>("GET /api/ships/:shipId/trips/:tripId/days", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/trips/:tripId/days", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewAll,
    }),
    create: (a: ApiArgs<DayApiEndpoints, "POST /api/ships/:shipId/trips/:tripId/days">) => ({
      call: (): Promise<IDayResponse> => {
        assertTarget(this.client, "POST /api/ships/:shipId/trips/:tripId/days", dayApiEndpoints["POST /api/ships/:shipId/trips/:tripId/days"].targets);
        return this.client.call<IDayResponse>("POST /api/ships/:shipId/trips/:tripId/days", a);
      },
      url: (): string => this.client.url("POST /api/ships/:shipId/trips/:tripId/days", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.editCurrent,
    }),
    update: (a: ApiArgs<DayApiEndpoints, "PUT /api/ships/:shipId/days/:dayId">) => ({
      call: (): Promise<IDayResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/days/:dayId", dayApiEndpoints["PUT /api/ships/:shipId/days/:dayId"].targets);
        return this.client.call<IDayResponse>("PUT /api/ships/:shipId/days/:dayId", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/days/:dayId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.editCurrent,
    }),
    calculate: (a: ApiArgs<DayApiEndpoints, "PUT /api/ships/:shipId/days/:dayId/calculate">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/days/:dayId/calculate", dayApiEndpoints["PUT /api/ships/:shipId/days/:dayId/calculate"].targets);
        return this.client.call<IAppResponse>("PUT /api/ships/:shipId/days/:dayId/calculate", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/days/:dayId/calculate", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
  };
}
